import { PROTOCOL_LINK_REGEX } from '@common/constants/url';

export const getLinkHref = (link: string) => {
  return link.match(PROTOCOL_LINK_REGEX) ? link : window.location.pathname.replace(window.location.pathname, link);
};
